import { render, staticRenderFns } from "./PaymentRequestModal.vue?vue&type=template&id=390320a2"
import script from "./PaymentRequestModal.vue?vue&type=script&lang=js"
export * from "./PaymentRequestModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports